export default __webpack_public_path__ + "static/media/alten.826a186a.png";